import React from 'react';
import * as BS from 'react-bootstrap';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  labelColProps: PropTypes.object,
  childrenColProps: PropTypes.object,
  className: PropTypes.string,
};

const FormGroupInline = ({
  label,
  children,
  error,
  touched,
  labelColProps,
  childrenColProps,
  className,
}) => {
  return (
    <BS.FormGroup
      validationState={touched && error ? 'error' : null}
      className={className}
    >
      {label && (
        <BS.Col componentClass={BS.ControlLabel} sm={2} {...labelColProps}>
          {label}
        </BS.Col>
      )}
      <BS.Col sm={label ? 10 : 12} {...childrenColProps}>
        {children}
        {touched && error && <BS.HelpBlock>{error}</BS.HelpBlock>}
      </BS.Col>
    </BS.FormGroup>
  );
};

FormGroupInline.propTypes = propTypes;

export default FormGroupInline;
